var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"Flashes",attrs:{"o-base":"flex:v pad:yEnd100 rhy:yStart"}},[_c('flash-block')],1)}
var staticRenderFns = []

export { render, staticRenderFns }